
import { uniqueToken, BaseURL } from "../api/DataApis";
import request from "./request";


export const fetchStatusList = async () => {
   
    const StatusApi = `${BaseURL}/settings/connector_status/status`;
  
      let res = await request({
        url: StatusApi,
        // url: 'posts',
        method: "GET",
      
        headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
  
      if (res && res?.data) {
        //const data = res.data.student;
        // console.log("res",res.students)
        return res?.data
      }
      return [];
  }